module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_pc_004-cdab2d539147dc1f43c0d231a6ba0849.png";